import {
  Button,
  Dropdown,
  Heading,
  Paragraph,
} from "@digdir/designsystemet-react";
import {
  ArrowRightLeftIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CogIcon,
  LeaveIcon,
  PersonCircleIcon,
} from "@navikt/aksel-icons";
import { Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "@/assets/logo.svg?react";
import { env } from "@/env";
import { useAuth } from "@/features/auth";
import { cn } from "@/utils";

export function Header() {
  const naviagte = useNavigate();
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  return (
    <header
      className={cn(
        "border-b border-balder-border-subtle h-header",
        "flex items-center",
      )}
    >
      <div
        className={cn(
          "max-w-page w-full mx-auto flex items-center justify-between pl-5",
          isAuthenticated ? "2xl:pl-5" : "2xl:pl-1", // Innloggede sidene har litt annen padding
        )}
      >
        <Link
          to={isAuthenticated ? "/bestillinger" : "/"}
          className="text-inherit no-underline py-4 group"
        >
          <Heading
            data-size="xs"
            className="flex gap-2 items-center group-hover:text-balder-text-subtle"
          >
            <Logo
              aria-hidden
              aria-label="Norgespris fjernvarme logo"
              className="inline w-[32px] h-[32px] group-hover:text-balder-text-subtle"
            />
            <span className="hidden sm:flex">{t("app.tittel")}</span>
          </Heading>
        </Link>
        <div className="flex items-center gap-0 my-2">
          {isAuthenticated ? (
            <AccountInfo />
          ) : (
            <Button
              variant="tertiary"
              onClick={() => naviagte({ to: "/auth/logg-inn" })}
            >
              <PersonCircleIcon fontSize="1.5rem" className="shrink-0" />
              {t("button.login")}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

function AccountInfo() {
  const { t } = useTranslation();
  const { account, signoutRedirect } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <Dropdown.TriggerContext>
      <Dropdown.Trigger
        variant="tertiary"
        className="flex items-center gap-2"
        onClick={() => setOpen((prev) => !prev)}
      >
        <PersonCircleIcon fontSize="1.5rem" className="shrink-0" />
        <Paragraph className="hidden sm:flex">{account?.navn}</Paragraph>
        {open ? <ChevronUpIcon aria-hidden /> : <ChevronDownIcon aria-hidden />}
      </Dropdown.Trigger>
      <Dropdown
        open={open}
        placement="bottom-end"
        onClose={() => setOpen(false)}
      >
        <Dropdown.Item>
          <Dropdown.Button onClick={() => navigate({ to: "/selskap" })}>
            <ArrowRightLeftIcon fontSize="1.5rem" />
            <span>{t("header.handlinger.velg-aktoer")}</span>
          </Dropdown.Button>
        </Dropdown.Item>
        {env.featureInnstillingerEnabled && (
          <Dropdown.Item>
            <Dropdown.Button onClick={() => navigate({ to: "/innstillinger" })}>
              <CogIcon fontSize="1.5rem" />
              <span>{t("header.handlinger.innstillinger")}</span>
            </Dropdown.Button>
          </Dropdown.Item>
        )}
        <Dropdown.Item>
          <Dropdown.Button onClick={signoutRedirect}>
            <LeaveIcon fontSize="1.5rem" />
            <span>{t("header.handlinger.logg-ut")}</span>
          </Dropdown.Button>
        </Dropdown.Item>
      </Dropdown>
    </Dropdown.TriggerContext>
  );
}
